export const timezoneDirection = (timezoneOffset) => {
  return (-timezoneOffset) >= 0 ? '+' : '-';
};

export const toIsoWithTimezoneString = (date) => {
  const timezone = date.getTimezoneOffset();
  const timezoneSignedDirection = timezoneDirection(timezone);
  const pad = function (num) {
    const norm = Math.floor(Math.abs(num));
    return (norm < 10 ? '0' : '') + norm;
  };
  return date.getFullYear()
    + '-' + pad(date.getMonth() + 1)
    + '-' + pad(date.getDate())
    + 'T' + pad(date.getHours())
    + ':' + pad(date.getMinutes())
    + ':' + pad(date.getSeconds())
    + timezoneSignedDirection + pad(timezone / 60)
    + ':' + pad(timezone % 60);
};
